import React from "react";
import HomeData from "../../../data/home.json";
import SectionTitle from "../../../components/section-title";
import Button from "../../../components/button";
import BlogGrid from "./details";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";

const HomeDigitalLending = ({ classOption = "mt-10 mt-lg-0 mb-7" }) => {
    const onClickHandler = () => {
        const element = document.getElementById("footer-section");
        element?.scrollIntoView({
            behavior: "smooth",
        });
    };

    return (
        <div className={`blog-section y-background-color ${classOption}`}>
            <div className="container">
                <div className="row mb-2">
                    <div className="col-xl-8 col-lg-8 mx-auto text-center">
                        <SectionTitle
                            classOption="title-section text-center mb-5"
                            subTitle=""
                            title="<span class='text-primary'>Digital Lending </span>at NeoGrowth"
                            excerptClassOption="null"
                            excerpt=""
                        />
                        {/* <Button
                            classOption="btn btn-xm btn-primary btn-hover-primary"
                            text="Products"
                            path="/loan"
                        /> */}
                    </div>
                </div>

                <div className="row">
                    <div key="1" className="col-lg-5 col-sm-6 mb-5">
                        <div className="blog-card">
                            <div className="thumb text-center digital-home-box  mb-7">
                                <img
                                    src="/images/icon/NeoCash-Express.png"
                                    alt="img"
                                    className="logo radius-box mb-3"
                                    width={"15%"}
                                />
                                <h3 className="text-dark">
                                    Digital Lending Products
                                </h3>
                            </div>
                            <div className="row justify-content-center">
                                <div
                                    key="1"
                                    className="col-lg-6 col-sm-6 mb-10"
                                >
                                    <Link
                                        to={
                                            process.env.PUBLIC_URL + "/products"
                                        }
                                    >
                                        <div className="blog-content text-center digital-home-button">
                                            <p className="">
                                                <b>NeoCash Insta</b>
                                            </p>
                                        </div>
                                    </Link>
                                </div>
                                <div key="2" className="col-lg-6 col-sm-6 mb-7">
                                    <Link
                                        to={
                                            process.env.PUBLIC_URL + "/products"
                                        }
                                    >
                                        <div className="blog-content text-center digital-home-button">
                                            <p className="">
                                                <b>NeoCash Express</b>
                                            </p>
                                        </div>
                                    </Link>
                                </div>
                                <div
                                    key="2"
                                    className="col-lg-6 col-sm-6 mb-7 mt-3"
                                >
                                    <Link
                                        to={
                                            process.env.PUBLIC_URL + "/products"
                                        }
                                    >
                                        <div className="blog-content text-center digital-home-button">
                                            <p className="">
                                                <b>SCF Banking</b>
                                            </p>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div key="2" className="col-lg-2 col-sm-1"></div>
                    <div key="3" className="col-lg-5 col-sm-6 mb-5">
                        <div className="blog-card">
                            <div className="thumb text-center digital-home-box  mb-7">
                                <img
                                    src="/images/icon/NeoCash.png"
                                    alt="img"
                                    className="logo radius-box mb-3"
                                    width={"15%"}
                                />
                                <h3 className="text-dark">
                                    Digital Lending Apps
                                </h3>
                            </div>
                            <div className="row">
                                <div
                                    key="1"
                                    className="col-lg-6 col-sm-6 mb-10"
                                >
                                    <a
                                        href={
                                            process.env.PUBLIC_URL +
                                            "/downloadneogrowthapp"
                                        }
                                    >
                                        <div className="blog-content text-center digital-home-button">
                                            <p className="">
                                                <b>NeoGrowth App</b>
                                            </p>
                                        </div>
                                    </a>
                                </div>
                                <div key="3" className="col-lg-6 col-sm-6 mb-7">
                                    <a
                                        href="https://instaas2.neogrowth.in"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <div className="blog-content text-center digital-home-button">
                                            <p className="">
                                                <b>NeoCash Insta</b>
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row text-center pb-5">
                    <p className="hover-green-txt">
                        <button
                            onClick={onClickHandler}
                            className="hover-green-txt"
                        >
                            Policies | Sachet | CMS | Customer Support
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
};

HomeDigitalLending.propTypes = {
    classOption: PropTypes.string,
};

export default HomeDigitalLending;
